import type { CompanyInformationResponse } from "@/types/auth.types";
import { api } from "./api";

export interface CompanyStatus {
  isActive: boolean;
  name: string;
}

/**
 * Vérifier le statut de l'entreprise (actif / nom)
 */
export const checkCompanyStatus = async (): Promise<CompanyStatus> => {
  try {
    const response = await api.get<CompanyStatus>("/auth/pointeuse/status");
    return response.data;
  } catch (error: unknown) {
    const err = error as { response?: { status?: number } };
    if (err.response?.status === 401) {
      throw new Error("Token invalide ou manquant. Veuillez vous reconnecter.");
    }
    throw new Error(
      (error as { response?: { data?: { message?: string } } }).response?.data
        ?.message || "Erreur lors de la récupération du statut de l'entreprise"
    );
  }
};

/**
 * Récupère le profil entreprise côté serveur (GET /auth/pointeuse/company-information).
 * À utiliser lors de la synchronisation manuelle pour mettre à jour le localStorage.
 */
export const fetchPointeuseCompanyProfile =
  async (): Promise<CompanyInformationResponse> => {
    try {
      const response = await api.get<CompanyInformationResponse>(
        "/auth/pointeuse/company-information"
      );
      return response.data;
    } catch (error: unknown) {
      const err = error as { response?: { status?: number; data?: { message?: string } } };
      if (err.response?.status === 401) {
        throw new Error(
          "Session expirée ou invalide. Reconfigurez la pointeuse depuis l’écran d’accueil."
        );
      }
      throw new Error(
        err.response?.data?.message ||
          "Erreur lors de la récupération des informations de l'entreprise"
      );
    }
  };
